const featureItems = [
  {
    icon: 'ri-scroll-to-bottom-line',
    title: '下拉式阅读',
    desc: '独创下拉式漫画浏览模式，全卷漫画一个页面看完，无需反复翻页。漫画完整版一气呵成，阅读体验流畅沉浸。',
    color: 'primary',
  },
  {
    icon: 'ri-book-read-line',
    title: '漫画全卷收录',
    desc: '专注收集完结漫画全集资源，从第一话到最终话完整收录。无论是经典老漫还是热门新作，漫画大全应有尽有。',
    color: 'accent',
  },
  {
    icon: 'ri-smartphone-line',
    title: '多端完美适配',
    desc: '电脑、手机、平板全设备完美适配。移动端浏览器打开即读，无需下载安装，随时随地畅享全集漫画免费阅读。',
    color: 'secondary',
  },
  {
    icon: 'ri-shield-check-line',
    title: '纯净安全免费',
    desc: '完全免费，无需注册登录，无弹窗广告骚扰。安全纯净的阅读环境，让您专注于漫画全集内容本身。',
    color: 'primary',
  },
  {
    icon: 'ri-flashlight-line',
    title: '极速更新同步',
    desc: '每日更新热门漫画最新话，与首发平台同步。海量漫画完整版资源持续扩充，追更补番两不误。',
    color: 'accent',
  },
];

const colorMap: Record<string, { bg: string; icon: string; badge: string }> = {
  primary: { bg: 'bg-primary-100', icon: 'text-primary-600', badge: 'bg-primary-100 text-primary-700' },
  accent: { bg: 'bg-accent-100', icon: 'text-accent-600', badge: 'bg-accent-100 text-accent-700' },
  secondary: { bg: 'bg-secondary-100', icon: 'text-secondary-600', badge: 'bg-secondary-100 text-secondary-700' },
};

export default function SectionFeatures() {
  return (
    <section id="features" className="py-14 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900 mb-3">
            平台特色
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            为什么选择虫虫动漫来看漫画全集
          </p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-5">
          {featureItems.map((item, idx) => {
            const colors = colorMap[item.color];
            return (
              <div key={idx} className="bg-background-50 rounded-xl p-5 text-center group hover:-translate-y-1 transition-transform duration-300 cursor-pointer">
                <div className={`w-12 h-12 rounded-xl ${colors.bg} flex items-center justify-center mx-auto mb-4`}>
                  <i className={`${item.icon} text-xl ${colors.icon}`}></i>
                </div>
                <h3 className="font-heading text-sm font-semibold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-xs text-foreground-600 leading-relaxed">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}